import FigureAutomation from './FigureAutomation';

export default FigureAutomation;
